document.addEventListener('DOMContentLoaded', function () {
  // Get all quick add buttons
  document.querySelectorAll('.quick-add__submit').forEach(function(button) {
    button.addEventListener('click', function(e) {
      // Find the nearest quantity input in the same card
      var card = button.closest('.card-wrapper');
      if (!card) return;

      var quantityInput = card.querySelector('input[name="quantity"]');
      if (!quantityInput) return;

      // If you have a custom counter, read its value
      var customCounter = card.querySelector('.quantity-input');
      if (customCounter) {
        quantityInput.value = customCounter.value;
      }
    });
  });
});
